export enum DrawType {
    Automatic = 1,
    Manual = 2,
}
